export enum ReportStatus {
    Pending = 1,
    InProcess = 2,
    Processed = 3,
    Error = 4
}

export enum ReportType {
    ReportComplaint = 1,
    ReportAlert = 2,
    ReportCase = 3,
    FlatReportComplaint = 4,
    FlatReportAlert = 5,
    FlatReportCase = 6,

    FlatReporFiles = 23,
    //Dynamic Filters
    FlatReportComplaintForDynamicFilter=24,
    FlatReportAlertForDynamicFilter =25,
    FlatReportCaseForDynamicFilter =26,
    FlatReportFilesForDynamicFilter = 27,

    //Advanced Filter
    FlatReportAlertByComplaint = 28,
    FlatReportCaseByAlert = 29,
}